import type { FrenchVoicePreferences, VoicePreferences } from "./speech";
import { registerLearningMediaCleanup, setLearningMediaActive } from "./learning-media";

export type LocalAudioAsset={id:string;url:string;voiceName:string;voiceLabel?:string;accent:string;gender:"female"|"male"|"unknown";durationMs:number|null;sha256:string;profileId?:string;engine?:string;modelVersion?:string;provenance?:string;sourceLicense?:string;preferred?:boolean};
type Preferences=VoicePreferences&FrenchVoicePreferences;
let activeAudio:HTMLAudioElement|null=null;
const LOCAL_AUDIO_MEDIA_SOURCE="local-course-audio";

export function selectLocalAudio(assets:LocalAudioAsset[]|undefined,language:"en"|"fr",preferences:Preferences,override:{accent?:"en-GB"|"en-US";gender?:"female"|"male"}={}){
  if(!assets?.length)return null;
  const accent=language==="fr"?"fr-FR":override.accent||preferences.voiceAccent||"en-GB";
  const gender=language==="fr"?preferences.frenchVoiceGender||"female":override.gender||preferences.voiceGender||"female";
  const matching=assets.filter(asset=>asset.accent===accent&&asset.gender===gender);
  return matching.find(asset=>asset.preferred)||matching[0]||null;
}

export async function playLocalAudio(assets:LocalAudioAsset[]|undefined,language:"en"|"fr",preferences:Preferences,override:{accent?:"en-GB"|"en-US";gender?:"female"|"male"}={}){
  if(typeof Audio==="undefined")return false;
  const selected=selectLocalAudio(assets,language,preferences,override);if(!selected)return false;
  stopLocalAudio();
  const audio=new Audio(selected.url);activeAudio=audio;audio.preload="auto";audio.playbackRate=language==="fr"?preferences.frenchVoiceRate||.84:preferences.voiceRate||.86;
  audio.onended=()=>{if(activeAudio===audio){activeAudio=null;setLearningMediaActive(LOCAL_AUDIO_MEDIA_SOURCE,false)}};audio.onerror=()=>{if(activeAudio===audio){activeAudio=null;setLearningMediaActive(LOCAL_AUDIO_MEDIA_SOURCE,false)}};
  try{await audio.play();setLearningMediaActive(LOCAL_AUDIO_MEDIA_SOURCE,true);return true}catch{if(activeAudio===audio)activeAudio=null;setLearningMediaActive(LOCAL_AUDIO_MEDIA_SOURCE,false);return false;}
}

export function stopLocalAudio(){
  if(activeAudio){activeAudio.onended=null;activeAudio.onerror=null;activeAudio.pause();activeAudio.src="";activeAudio=null}
  setLearningMediaActive(LOCAL_AUDIO_MEDIA_SOURCE,false);
}

registerLearningMediaCleanup(stopLocalAudio);
